/* [LUZGURU] Barra de compra fija en móvil/tablet (PDP).
   Reenvía el clic al botón real (#ProductSubmitButton-<section>) y sincroniza
   precio/estado. Re-consulta el DOM en cada sincronización porque Dawn
   reemplaza nodos al cambiar de variante (misma pauta que lg-shipping-bar.js). */
if (!customElements.get('lg-sticky-atc')) {
  customElements.define(
    'lg-sticky-atc',
    class LgStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-lg-sticky-button]');
        this.label = this.querySelector('[data-lg-sticky-label]');
        this.price = this.querySelector('[data-lg-sticky-price]');
        if (!this.button || !this.getMainButton()) return;

        this.button.addEventListener('click', this.onClick.bind(this));
        this.observeMainButton();
        this.sync();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            window.setTimeout(() => {
              this.observeMainButton();
              this.sync();
            }, 0);
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.buttonObserver) this.buttonObserver.disconnect();
      }

      getMainButton() {
        return document.getElementById('ProductSubmitButton-' + this.sectionId);
      }

      observeMainButton() {
        const main = this.getMainButton();
        if (!main || main === this.observedButton) return;
        this.observedButton = main;

        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        const target = main.closest('.product-form__buttons') || main;
        this.visibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          // Solo cuando el botón real ha quedado por ENCIMA del viewport.
          this.setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.visibilityObserver.observe(target);

        if (this.buttonObserver) this.buttonObserver.disconnect();
        this.buttonObserver = new MutationObserver(() => this.sync());
        this.buttonObserver.observe(main, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true, characterData: true });
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        this.button.tabIndex = visible ? 0 : -1;
        document.body.classList.toggle('lg-sticky-atc-open', visible);
      }

      sync() {
        const main = this.getMainButton();
        if (!main) return;

        const disabled = main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true';
        const isLoading = main.classList.contains('loading');
        // aria-disabled (no `disabled`) para que el clic siga llegando y
        // podamos llevar al usuario al aviso de reposición si está agotado.
        this.button.setAttribute('aria-disabled', disabled && !isLoading ? 'true' : 'false');
        this.button.classList.toggle('is-loading', isLoading);

        const mainLabel = main.querySelector('span');
        if (mainLabel && this.label) {
          const text = mainLabel.textContent.trim();
          if (text) this.label.textContent = text;
        }

        const priceWrap = document.getElementById('price-' + this.sectionId);
        if (priceWrap && this.price) {
          const priceEl = priceWrap.querySelector('.price');
          if (priceEl) {
            const onSale = priceEl.classList.contains('price--on-sale');
            const current = onSale
              ? priceEl.querySelector('.price__sale .price-item--last')
              : priceEl.querySelector('.price__regular .price-item--regular');
            if (current && current.textContent.trim()) this.price.textContent = current.textContent.trim();
          }
        }
      }

      onClick() {
        const main = this.getMainButton();
        if (!main) return;
        if (main.disabled) {
          // Sin variante disponible: llevar al usuario al selector / aviso de reposición.
          main.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        main.click();
      }
    }
  );
}
